module.exports = __webpack_public_path__ + "resources/img/img_vehicle.03c645e978ec3cbc94311e6f42a667a6.png";